import { Component, signal, output, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

const ALPHABETS = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

@Component({
  standalone: true,
  selector: 'app-a-z-filter',
  imports: [CommonModule],
  template: `
    <div class="alphabet-selector">
      <div class="alphabet-container" >
        <span (click)="alphabetFilter(alphabet)"
          class="alphabet-label" [class.alphabet-active]="alphabet === selectedAlphabet()"
          *ngFor="let alphabet of alphabets"
          >{{ alphabet }}</span
        >
      </div>
    </div>
  `
})
export class AZFilterComponent {
  alphabets = ALPHABETS;

  private _selectedAlphabet = signal<string>("");
  readonly selectedAlphabet = this._selectedAlphabet.asReadonly();

  readonly hasSelectedAlphabet = computed(() => !!this._selectedAlphabet());

  // Update output to use Angular 20 output() function
  alphabetFilterEvent$ = output<string>();

  constructor() {
    // The constructor is no longer needed for @Output
  }

  alphabetFilter(alphabet: string) {
    const lastSelectedAlphabet = this._selectedAlphabet();
    this._selectedAlphabet.set(alphabet);
    this.alphabetFilterEvent$.emit(alphabet);

    if (lastSelectedAlphabet === alphabet) {
      this._selectedAlphabet.set("");
      this.alphabetFilterEvent$.emit("");
    }
  }
}

